var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.isTaskOperate && _vm.opreateText.numText ? _c('div', {
    staticClass: "content-red",
    style: {
      'background-image': 'url(https://map-push.cdn.bcebos.com/53211bed38cbc8b55e7795a03fb5f058.png)'
    },
    on: {
      "click": _vm.operateClick
    }
  }, [_c('div', {
    staticClass: "text",
    class: {
      'max-text': _vm.opreateText.numText === '请登录'
    }
  }, [_vm._v(" " + _vm._s(_vm.opreateText.numText) + " ")]), _c('div', {
    staticClass: "bottom-text"
  }, [_vm._v(" " + _vm._s(_vm.opreateText.bottomText) + " ")]), _vm.couponObj.showCoupon ? _c('taskDialog', {
    attrs: {
      "bg": _vm.couponObj.couponImg,
      "bg-height": _vm.couponObj.bgHeight,
      "bg-width": _vm.couponObj.bgWidth
    },
    on: {
      "close-task-dialog": _vm.closeCoupon,
      "click-content": _vm.clickContent
    }
  }, [_vm.couponObj.couponTitle ? _c('div', {
    staticClass: "title"
  }, [_vm._v(" " + _vm._s(_vm.couponObj.couponTitle))]) : _vm._e(), _c('div', {
    staticClass: "coupon-content-text"
  }, [_c('div', [_vm._v("恭喜您")]), _c('div', [_vm._v(" " + _vm._s(_vm.couponObj.contentText) + " ")]), _vm.couponObj.score ? _c('div', {
    staticClass: "score"
  }, [_c('span', {
    staticClass: "score-money"
  }, [_vm._v(" " + _vm._s(_vm.couponObj.score) + " ")]), _c('span', {
    staticClass: "score-text"
  }, [_vm._v("元")])]) : _vm._e()])]) : _vm._e()], 1) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };